import {ExtendedComponentSchema} from "formiojs";
import {FormioForm} from "@formio/angular";

export interface FormChangesDelta {
    additions: FormFieldChange[],
    deletions: FormFieldChange[],
    editions: FormFieldChange[],
}

export interface FormFieldChange {
    component: FormComponent,
    changes?: FormChangesDelta,
    action: FormFieldChangeAction,
}

export enum FormFieldChangeAction {
    Add = "add",
    Edit = "edit",
    Remove = "remove",
}

export interface FormFieldDataUpdate {
    key: string,
    value: string,
    type?: string,
    action: FormFieldChangeAction,
    updates: FormFieldDataUpdate[]
}

export interface FormDataChangesColumnSettings {
    field: string;
    header: string;

    hide?(): boolean;

    empty?(change: FormFieldDataChange): boolean;

    editable?(change: FormFieldDataChange): boolean;
}

export class FormComponent {
    constructor(public readonly component: ExtendedComponentSchema, public readonly path: string, public index: number = 0) {
    }

    get key(): string {
        return this.component.key;
    }

    get type(): string {
        return this.component.type;
    }

    get id(): string {
        return `${this.type}-${this.key}`;
    }
}

export class FormFieldDataChange {
    private readonly nonEditableFields: string[];
    public readonly form: FormioForm;
    public readonly formData: any;

    constructor(private readonly change: FormFieldChange) {
        this.nonEditableFields = ["datagrid", "table", "columns"];
        this.form = {components: [change.component.component]};
        this.formData = {data: {[this.key]: null}};
    }

    get component(): ExtendedComponentSchema {
        return this.change.component.component;
    }

    get path(): string {
        return this.change.component.path;
    }

    get index(): number {
        return this.change.component.index;
    }

    get name(): string {
        return this.component.label;
    }

    get key(): string {
        return this.component.key;
    }

    get type(): string {
        return this.component.type;
    }

    get id(): string {
        return this.component.id;
    }

    get action(): string {
        return this.change.action;
    }

    get value(): string {
        return this.formData.data[this.key];
    }

    set value(value: string) {
        this.formData.data = {[this.key]: value};
    }

    get editable(): boolean {
        return this.change.action === FormFieldChangeAction.Add
            && !this.nonEditableFields.includes(this.type)
            && !this.component.components?.length;
    }
}